var _path, _mask, _path2, _mask2, _path3, _path4, _path5, _mask3, _rect, _mask4, _rect2, _mask5, _rect3, _mask6, _rect4, _mask7, _rect5, _mask8, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotel = function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M11 8v29h28V8z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.43a.43.43 0 0 1 .43-.43h12.14a.43.43 0 0 1 .43.43v6.141a.43.43 0 0 1-.429.429H18.93a.43.43 0 0 1-.429-.429z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 30.43c0-.79.64-1.43 1.43-1.43h12.14c.79 0 1.43.64 1.43 1.43l-2 .57h-11zm14 6.57h-13zm-12.571 0c-.79 0-1.429-.64-1.429-1.429V30.43c0-.79.64-1.43 1.43-1.43l.57 2v6zm12.141-8c.79 0 1.43.64 1.43 1.43v5.141c0 .79-.64 1.429-1.429 1.429H30.5v-6z",
    mask: "url(#hotel_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.43a.43.43 0 0 1 .43-.43h18.14a.43.43 0 0 1 .43.43v2.141a.43.43 0 0 1-.429.429H15.93a.43.43 0 0 1-.429-.429z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 5.43c0-.79.64-1.43 1.43-1.43h18.14c.79 0 1.43.64 1.43 1.43l-2 .57h-17zM34.5 8h-19zM15.929 8c-.79 0-1.429-.64-1.429-1.429V5.43c0-.79.64-1.43 1.43-1.43l.57 2v2zM34.07 4c.79 0 1.43.64 1.43 1.43v1.141c0 .79-.64 1.429-1.429 1.429H33.5V6z",
    mask: "url(#hotel_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M25 37v-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M20.382 28.5h9.236a2.38 2.38 0 0 1 2.348 2H18.034a2.38 2.38 0 0 1 2.348-2Z"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 15.98,
    y: 12,
    rx: 0.383
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 15.98,
    y: 12,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#hotel_svg__c)",
    rx: 0.383
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 22.98,
    y: 12,
    rx: 0.383
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 22.98,
    y: 12,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#hotel_svg__d)",
    rx: 0.383
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 29.98,
    y: 12,
    rx: 0.383
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 29.98,
    y: 12,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#hotel_svg__e)",
    rx: 0.383
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 15.98,
    y: 19,
    rx: 0.383
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 15.98,
    y: 19,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#hotel_svg__f)",
    rx: 0.383
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 22.98,
    y: 19,
    rx: 0.383
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 22.98,
    y: 19,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#hotel_svg__g)",
    rx: 0.383
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 29.98,
    y: 19,
    rx: 0.383
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    x: 29.98,
    y: 19,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#hotel_svg__h)",
    rx: 0.383
  })));
};
export default SvgHotel;